export default "__VITE_ASSET__KKxns6OT__"